import { IntlShape } from 'react-intl';

const toCamel = (s: string): string =>
    s.replace(/_([a-z])/g, (_m, c: string) => c.toUpperCase());

export const detectorName = (
    intl: IntlShape,
    detectorId: string,
    fallback?: string,
): string =>
    intl.formatMessage({
        id: `responseIntegrity.detector.${toCamel(detectorId)}.name`,
        defaultMessage: fallback ?? detectorId,
    });

export const detectorDescription = (
    intl: IntlShape,
    detectorId: string,
): string =>
    intl.formatMessage({
        id: `responseIntegrity.detector.${toCamel(detectorId)}.description`,
        defaultMessage: '',
    });

export const profileName = (
    intl: IntlShape,
    profileId: string,
    fallback?: string,
): string =>
    intl.formatMessage({
        id: `responseIntegrity.profile.${toCamel(profileId)}.name`,
        defaultMessage: fallback ?? profileId,
    });

export const profileDescription = (
    intl: IntlShape,
    profileId: string,
    fallback?: string | null,
): string =>
    intl.formatMessage({
        id: `responseIntegrity.profile.${toCamel(profileId)}.description`,
        defaultMessage: fallback ?? '',
    });

export const categoryLabel = (intl: IntlShape, category: string): string =>
    intl.formatMessage({
        id: `responseIntegrity.detectorCategory.${category}`,
        defaultMessage: category,
    });
